// Webpacker pack for the /teens-adult marketing page.

// Reveal-on-scroll: elements with class="reveal" fade + rise into place
// when they enter the viewport. Each element animates once.
function initRevealOnScroll() {
  const targets = document.querySelectorAll('.tp-adults-page .reveal');
  if (targets.length === 0) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  targets.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRevealOnScroll);
} else {
  initRevealOnScroll();
}
